import { render, staticRenderFns } from "./SelectFrequency.vue?vue&type=template&id=04228d42"
import script from "./SelectFrequency.vue?vue&type=script&lang=js"
export * from "./SelectFrequency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports